import { render, staticRenderFns } from "./reviewPaperList.vue?vue&type=template&id=aa43f518&scoped=true"
import script from "./reviewPaperList.vue?vue&type=script&lang=js"
export * from "./reviewPaperList.vue?vue&type=script&lang=js"
import style0 from "./reviewPaperList.vue?vue&type=style&index=0&id=aa43f518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa43f518",
  null
  
)

export default component.exports